import { schema } from "normalizr";

const PriceListSchema = new schema.Entity("priceLists");
const PriceListArraySchema = new schema.Array(PriceListSchema);

export { PriceListSchema, PriceListArraySchema };